import { Paper, Stack, Typography } from '@mui/material';
import { setMatchScore } from '../../../actions/points';
import { isEntered } from '../../../domain/matchSchedule';
import type { DraftMatch } from '../../../domain/matchSchedule';
import { useAppDispatch } from '../../../hooks';
import SetCounter from './SetCounter';

const MAX_SETS_PER_PLAYER = 15;

interface Props {
  match: DraftMatch;
  expectedSets: number;
}

export default function MatchRow({ match, expectedSets }: Props) {
  const dispatch = useAppDispatch();
  const player1Score = match.player1Score ?? 0;
  const player2Score = match.player2Score ?? 0;
  const total = player1Score + player2Score;
  const entered = isEntered(match);

  return (
    <Paper
      className="wynik"
      variant="outlined"
      sx={{
        p: 1.25,
        borderColor: entered ? 'success.light' : 'divider',
        backgroundColor: entered ? 'success.50' : 'transparent'
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        spacing={1}
        sx={{ mb: 0.75 }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {match.player1.name} – {match.player2.name}
        </Typography>
        {entered && total !== expectedSets && (
          <Typography variant="caption" color="warning.main">{total} setów</Typography>
        )}
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
        <SetCounter
          name={match.player1.name}
          value={player1Score}
          max={MAX_SETS_PER_PLAYER}
          onChange={(next) => dispatch(setMatchScore(match._id, next, player2Score))}
        />
        <Typography component="span" sx={{ px: 0.5, color: 'text.disabled' }}>:</Typography>
        <SetCounter
          name={match.player2.name}
          value={player2Score}
          max={MAX_SETS_PER_PLAYER}
          onChange={(next) => dispatch(setMatchScore(match._id, player1Score, next))}
        />
      </Stack>
    </Paper>
  );
}
